import React, { Component, createRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNewspaper, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { Link, Navigate } from "react-router-dom";
import { encryptAES } from '../../utils/Encryption';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';
import { CommonSuccessMessages } from '../../utils/Messages';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default class BlogList extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.dt = createRef();
        this.state = {
            data: [],
            newsblogList: [],
            route: null,
            isLoading: false,
            dateRange: null,
            totalRecords: 0,
            filterDetails: {
                start: 0,
                length: 10,
                search: '',
                roleId: '',
                sortField: '',
                sortOrder: 'asc',
                type: '',
                startDate: '',
                endDate: ''
            }
        };
        this.exportCSV = this.exportCSV.bind(this);
        this.exportPdf = this.exportPdf.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
        this.saveAsExcelFile = this.saveAsExcelFile.bind(this);
    }

    componentDidMount() {
        this.getNewsBlogList();
    }

    getNewsBlogList = () => {
        let filterDetials = this.state.filterDetails;
        this.setState({ isLoading: true })
        let request = [filterDetials.start,
        filterDetials.length,
        filterDetials.search,
        filterDetials.roleId,
        filterDetials.sortField,
        filterDetials.sortOrder,
        filterDetials.type,
        filterDetials.startDate && Number(moment(filterDetials.startDate).format('YYYYMMDD')),
        filterDetials.endDate && Number(moment(filterDetials.endDate).format('YYYYMMDD'))
        ];

        this.adminServices.getNewsBlogList(request).then((response) => {
            if (response && response.data && response !== null) {
                let res = response.data;
                res.map((x, index) => {
                    x.srNo = index + 1
                })
                this.setState({ newsblogList: res, totalRecords: response.totalRecords });
                this.setState({ isLoading: false })
            }
        });
    }

    actionBodyTemplate = (rowData) => {
        return (
            <div className="flex gap-2 justify-center">
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handleEdit(rowData)}
                    tooltip="Edit"
                    tooltipOptions={{ position: 'top' }}
                />
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handleDelete(rowData)}
                    tooltip="Delete"
                    tooltipOptions={{ position: 'top' }}
                />
            </div>
        );
    };


    handleEdit = (rowData) => {
        if (rowData.newsblogsid && rowData.newsblogsid > 0) {
            this.setState({ route: '/blog-details?=' + rowData.newsblogsid });
        }
    };

    handleDelete = (rowData) => {
        if (rowData.newsblogsid && rowData.newsblogsid > 0) {
            this.swalServices.Confirm(
                "",
                ``,
                CommonSuccessMessages.Yes_Text,
                CommonSuccessMessages.No_Text,
                `Are you sure you want to delete ?`
            ).then((response) => {
                if (response === true) {
                    this.adminServices.deleteNewsBlogs(rowData.newsblogsid).then((response) => {
                        if (response.success === 1) {
                            this.getNewsBlogList();
                            this.swalServices.Success(response.msg)
                        } else {
                            this.swalServices.Error(response.msg)
                        }
                        this.setState({ isLoading: false });
                    });
                }
            })
        }
    };

    handleSearch = (value) => {
        let details = this.state.filterDetails
        details.search = value;
        this.setState({ filterDetails: details }, () => {
            this.getNewsBlogList();

        });
    }

    handleChangeDateRange = (value) => {
        let details = this.state.filterDetails

        if (value[0]) {
            details.startDate = value[0];
            details.startDate = details.startDate.setHours(0, 0, 0, 0);
        }

        if (value[1]) {
            details.endDate = value[1];
            details.endDate = details.endDate.setHours(23, 59, 59, 999);
        }
        this.setState({ filterDetails: details, dateRange: value }, () => {
            if (this.state.filterDetails.startDate && this.state.filterDetails.endDate) {
                this.getNewsBlogList();
            }

        });
    }

    resetFilter = () => {
        let details = this.state.filterDetails
        details.search = '';
        details.startDate = '';
        details.endDate = '';
        this.setState({ filterDetails: details, dateRange: null }, () => {
            this.getNewsBlogList()
        });
    }

    onPageChange = (event) => {
        let details = this.state.filterDetails
        details.start = event.first;
        details.length = event.rows;
        this.setState({ filterDetails: details }, () => {
            this.getNewsBlogList();
        })
    };

    onSortChange = (event) => {
        const filterDetails = { ...this.state.filterDetails };
        filterDetails.sortField = event.sortField;
        filterDetails.sortOrder = event.sortOrder === 1 ? 'asc' : 'desc';
        this.setState({ filterDetails }, () => {
            this.getNewsBlogList();
        });
    };

    // exportCSV(selectionOnly) {
    //     if (this.dt.current) {
    //         this.dt.current.exportCSV({ selectionOnly });
    //     }
    // }

    exportCSV(selectionOnly) {
        if (this.dt.current) {
            const data = selectionOnly ? this.dt.current.props.value.filter(row => this.dt.current.isSelected(row)) : this.dt.current.props.value;

            let csv = '';
            let columns = this.dt.current.props.children;

            columns = columns.filter(col => col.props.header !== 'Actions');
            csv += columns.map(col => col.props.header).join(',') + '\n';

            data.forEach(rowData => {
                const row = columns.map(col => {
                    const field = col.props.field;
                    return '"' + (rowData[field] !== undefined ? rowData[field] : '') + '"';
                });
                csv += row.join(',') + '\n';
            });

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const filename = 'News Blog List.csv';

            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                const url = URL.createObjectURL(blob);
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    getExportColumns() {
        return this.state.newsblogList.map((col) => ({ title: 'ABC', dataKey: 'XYZ' }));
    }

    exportPdf() {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                const exportColumns = this.getExportColumns();
                doc.autoTable(exportColumns, this.state.newsblogList);
                doc.save('News Blog List.pdf');
            });
        });
    }

    saveAsExcelFile(buffer, fileName) {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], { type: EXCEL_TYPE });

                module.default.saveAs(data, "News Blog List" + EXCEL_EXTENSION);
            }
        });
    }

    exportExcel() {
        import('xlsx').then((xlsx) => {
            const modifiedData = this.state.newsblogList.map(({ newsblogsid, ...rest }) => {
                const { srNo, ...others } = rest;
                return { srNo, ...others };
            });

            const worksheet = xlsx.utils.json_to_sheet(modifiedData);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });

            this.saveAsExcelFile(excelBuffer, 'newsblogList');
        });
    }


    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }

        const pageSizes = [5, 10, 20, 50, 100];
        let rowsPerPageOptions = pageSizes.filter(size => size < this.state.totalRecords);

        if (!rowsPerPageOptions.includes(this.state.totalRecords)) {
            rowsPerPageOptions.push(this.state.totalRecords);
        }

        const paginatorRight = (
            <div className="flex gap-2">
                <Button label="Export CSV" icon="pi pi-file" className="export-btn" onClick={() => this.exportCSV(false)} />
                {/* <Button label="Export PDF" icon="pi pi-file-pdf" className="export-btn" onClick={this.exportPdf} /> */}
                <Button label="Export Excel" icon="pi pi-file-excel" className="export-btn" onClick={this.exportExcel} />
            </div>
        );

        return (
            <div className='blog-lists'
                style={{ height: "calc((100dvh / 0.85) - 60.8px)" }}
            >
                <div className='blog-lists-inner h-full p-[30px]'>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>Blog list</h1>
                        <Link to="/blog-details">
                            <button className='flex items-center gap-[5px] py-[5px] px-[10px] text-[14px] font-medium rounded-[5px] text-[#FFFFFF] bg-[#0077B6] hover:bg-[#3b82f6] border-0'><FontAwesomeIcon className='w-5 h-5' icon={faNewspaper} />Add blog</button>
                        </Link>
                    </div>
                    <div className='blog-table p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                        <div className='table-inner grid grid-cols-3 gap-5 items-end'>
                            <div className="input-grp !mb-0">
                                <label>
                                    Search
                                </label>
                                <InputText
                                    type="search"
                                    value={this.state.filterDetails.search}
                                    onChange={(e) => this.handleSearch(e.target.value)}
                                    placeholder="Search across all columns..."
                                    style={{ height: "42px" }}
                                />
                            </div>
                            <div className="input-grp !mb-0">
                                <label>
                                    Filter by Date Range
                                </label>
                                <Calendar
                                    value={this.state.dateRange}
                                    onChange={(e) => this.handleChangeDateRange(e.value)}
                                    selectionMode="range"
                                    placeholder="Select date range"
                                    dateFormat="dd-mm-yy"
                                    readOnlyInput
                                    numberOfMonths={2}
                                    maxDate={new Date()}
                                    style={{ height: "42px" }}
                                />
                            </div>
                            <Button
                                label="Reset filters"
                                className='w-fit h-fit'
                                onClick={() => this.resetFilter()}
                                style={{ fontWeight: "400", lineHeight: "1" }}
                            />
                        </div>
                        <div className='sub-table rounded-xl shadow-sm overflow-hidden border border-gray-200 bg-white mt-[30px]'>
                            <DataTable
                                value={this.state.newsblogList}
                                paginator
                                first={this.state.filterDetails.start}
                                rows={(this.state.totalRecords > this.state.filterDetails.length) ? this.state.filterDetails.length : this.state.totalRecords}
                                totalRecords={this.state.totalRecords}
                                lazy
                                rowsPerPageOptions={rowsPerPageOptions}
                                onPage={(e) => this.onPageChange(e)}
                                emptyMessage="No data found"
                                loading={this.state.isLoading}
                                loadingIcon={
                                    <div className="flex justify-center items-center w-full py-4">
                                        <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                    </div>
                                }
                                scrollable
                                scrollHeight="calc((100dvh / 0.85) - 360px)"
                                className="min-w-full"
                                onSort={(e) => this.onSortChange(e)}
                                sortField={this.state.filterDetails.sortField}
                                sortOrder={this.state.filterDetails.sortOrder === 'asc' ? 1 : -1}
                                paginatorRight={paginatorRight}
                                ref={this.dt}
                            >
                                <Column
                                    field="srNo"
                                    header="Sr No"
                                    body={(rowData, options) => options.rowIndex + 1}
                                    filterPlaceholder="Search by ID"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                ></Column>
                                <Column field="title" header="Title" sortable filterPlaceholder="Search by ID" headerClassName="bg-blue-50 text-blue-800 font-medium"></Column>
                                <Column field="category" header="Category" sortable filterPlaceholder="Search by ID" headerClassName="bg-blue-50 text-blue-800 font-medium"></Column>
                                <Column
                                    field="createddate"
                                    header="Created Date"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    field="createdby"
                                    header="Created By"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    field="modifieddate"
                                    header="Updated Date"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    field="modifiedby"
                                    header="Updated By"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                    sortable filterPlaceholder="Search by ID"
                                />
                                <Column
                                    header="Actions"
                                    body={this.actionBodyTemplate}
                                    style={{ textAlign: 'center', width: '10rem' }}
                                    headerClassName="bg-blue-50 text-blue-800 font-medium centered-header"
                                />
                            </DataTable>
                        </div>
                    </div>
                </div >
            </div >
        )
    }
}
